<div style ="text-align: center;"><p-progressSpinner class="spiner p-spinner" [hidden]="progressSpinner"
                   [style]="{width: '50px', height: '50px'}"
                   strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
</div>
<div [hidden]="PageContent">
<h5>PRODUCTION JOBS</h5>
<hr class="style-four">


<div style ="margin: 30px;text-align:center; ">
  <p-dropdown [options]="locations" [(ngModel)]="loc_pos" [filter]="true" [style]="{'width':'250px'}"
              (click)="locationClicked(loc_pos)" placeholder="Select a location">

    <ng-template let-item pTemplate="selectedItem">
      <img src="assets/image/flag/{{item.label}}.png" style="width:16px;vertical-align:middle;text-align: left" />
      <span style="vertical-align:middle;text-align: left">{{item.label}}</span>
    </ng-template>

    <ng-template let-loc pTemplate="item">
      <div class="ui-helper-clearfix" >
        <img src="assets/image/flag/{{loc.label}}.png" style="width:16px;vertical-align:middle;float:left;margin-right: 5px;text-align: left"/>
        <div  style="vertical-align:middle;text-align: left">{{loc.label}}</div>
      </div>
    </ng-template>

  </p-dropdown>

  <div style ="margin-top:30px;">
    <p-selectButton class="p-select-container" [options]="applications" [(ngModel)]="application" (click)="applicationClicked(application)" align="center" ></p-selectButton>
  </div>
</div>

<div style ="margin: 30px;text-align: center">
  <p-selectButton class="p-select-container" [options]="jobnames" [(ngModel)]="jobname" (click)="jobnameClicked(jobname)"></p-selectButton>
</div>



<div style="margin-top: 30px">
  <div  id="cardDiv" [hidden]="ExecutionCard" class="card" style="clear: left;">
    <div class="container">

      <div *ngIf="jobSelected[0] !== undefined">
        <h2 [style.color]="statusHandler(jobSelected[0].status)">{{jobSelected[0].startDate | date:'dd/MM/yyyy'}} ( {{jobSelected[0].startTime}} - {{jobSelected[0].endTime}})
        <b [style.color]="statusHandler(jobSelected[0].status)" [ngClass]="statusIconHandler(jobSelected[0].status)"
        style="margin-left: 8px;">{{jobSelected[0].status}} </b></h2>
      </div>

      <button class = "showmore" class="btn" (click)="showmore()" > <i class={{cardIcon}} style ="padding:3px;"></i> Previous Executions</button>
      <button class = "showmore" class="btn" (click)="showmoreForecast()"><i class={{cardIconForecast}}></i> Forecast Executions</button>

          <div *ngFor="let PreviousJobs of jobSelected" [hidden]="tabla" style="margin-top: 10px">
            <h2 [style.color]="statusHandler(PreviousJobs.status)">{{PreviousJobs.startDate | date:'dd/MM/yyyy'}} ( {{PreviousJobs.startTime}} - {{PreviousJobs.endTime}})
            <b [style.color]="statusHandler(PreviousJobs.status)" [ngClass]="statusIconHandler(PreviousJobs.status)"
               style="margin-left: 8px;">{{PreviousJobs.status}}</b></h2>
          </div>

      <div *ngFor="let ForecastJobs of jobForecast" [hidden]="tablaForecast" style="margin-top: 10px">
        <h2 [style.color]="statusHandler(ForecastJobs.status)">{{ForecastJobs.startDate | date:'dd/MM/yyyy'}} ( {{ForecastJobs.startTime}} - {{ForecastJobs.endTime}})
          <b [style.color]="statusHandler(ForecastJobs.status)" [ngClass]="statusIconHandler(ForecastJobs.status)"
             style="margin-left: 8px;">{{ForecastJobs.status}}</b></h2>
      </div>


    </div>
  </div>
</div>
</div>
